<template>
  <div class="login">
    <div class="forgot-password">
      <div class="logo">
        <img src="./../../assets/logo.png" />
      </div>

      <div class="forgot-password-text">
        <v-form>
          <v-text-field
            label="Correo"
            ref="email"
            prepend-icon="person"
            type="text"
            autofocus
            v-model="model.email"
          >
          </v-text-field>
        </v-form>

        <div>
          Si olvidaste tu contraseña haz click en enviar y te llegará un correo
          para reestablecerla.
        </div>

        <div class="btn-container">
          <div class="btn-forgot-password">
            <v-btn color="primary" @click="recover()">Enviar</v-btn>
          </div>

          <div class="btn-forgot-password">
            <v-btn @click="back()">Regresar</v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { events } from "./../../main";

export default {
  name: "login",

  components: {},

  data() {
    return {
      loading: false,
      model: {
        email: "",
      },
    };
  },

  props: {},

  methods: {
    recover() {
      var self = this;
      const recoverypasswordPayload = { email: this.model.email };
      this.loading = true;
      this.$http.post("user/recoverypassword", recoverypasswordPayload).then(
        (response) => {
          this.loading = false;
          this.snackbar(
            "La contraseña ha sido recuperada. Favor de revisar su correo."
          );
        },
        (err) => {
          console.log(err);
          this.loading = false;
          this.snackbar(
            "El correo electrónico ingresado no existe, favor de verificar."
          );
          self.model = {
            email: "",
          };
          self.$refs.email.focus();
        }
      );
    },

    back() {
      this.$router.push("login");
    },

    snackbar(message) {
      events.$emit("snackbar", message);
    },
  },

  computed: {},

  directives: {
    focus: {
      inserted: function (el) {
        el.focus();
      },
    },
  },

  watch: {},

  created() {},

  mounted() {},
};
</script>

<style scoped>
.login {
  height: 100%;
}

.forgot-password {
  text-align: left;
  height: 100%;
  background: #f5f5f5;
  color: #4b5156;
  width: 66%;
}

.logo {
  padding: 2%;
  text-align: left;
}

.logo img {
  height: 80px;
  width: auto;
}

.forgot-password-text {
  padding: 5%;
}

.title {
  color: white;
  font-size: 45px;
  margin-top: 50px;
  margin-bottom: 30px;
}

.subtitle {
  font-size: 30px;
  margin-bottom: 60px;
}

.forgot-password .forgot-password-text .btn-forgot-password button {
  background-color: #4b5156;
  color: white;
  margin-left: 0;
  margin-top: 30px;
}

.btn-container {
  display: flex;
  flex-direction: row-reverse;
}
</style>
